// STEP 3 combined · B6c (owner 27-Oct-2026) — THE frontend mirror of the one "balanced" rule. Its home is the backend's
// backend/tolerances.py `is_balanced` (rule 9a, B-9a): a difference is balanced when it rounds to 0.00 at 2 decimal places
// (|round(diff, 2)| < 0.01). The adjusting-entry and restatement dialogs, the lead-sheet "agrees to the statements" banner and
// the cash-flow tie note call this instead of their own `< 0.005`; the server still decides on Save / Post (an entry off by
// 0.01 is refused there too). src/__tests__/S3cB6cIsBalanced.test.js pins the same table of values as the backend test of
// tolerances (backend/tests/test_r9a_balance_tolerances.py) and fails when a dialog keeps its own literal.
export const BALANCE_TOLERANCE = 0.01;
export const BALANCE_DECIMALS = 2;

// A missing / non-numeric difference is never balanced (the backend refuses None; a screen shows "not balanced", never a guess).
export function isBalanced(diff) {
  if (diff == null || diff === "") return false;
  const d = Number(diff);
  if (!Number.isFinite(d)) return false;
  const f = 10 ** BALANCE_DECIMALS;
  return Math.round(Math.abs(d) * f) / f < BALANCE_TOLERANCE;   // abs first: rounding is symmetric for negatives, as Python's
}

// PRE-STEP 4 · 3b (owner 27-Oct-2026) — THE frontend mirror of backend/audit_adjustments.py `PROFIT_EFFECT_TOLERANCE` (0.01): a
// reclassification "changes profit" when |profit effect| is ABOVE it (a warning, never a balance verdict). The adjusting-entry
// dialog calls `changesProfit` (before: its own `> 0.005`, so a 0.01 effect warned on screen and not on the saved entry).
// backend/tests/test_pre_s4_3b_tolerances.py pins both mirrors here against the backend values.
export const PROFIT_EFFECT_TOLERANCE = 0.01;

export function changesProfit(effect) {
  const d = Number(effect);
  if (!Number.isFinite(d)) return false;
  return Math.abs(Math.round(d * 100) / 100) > PROFIT_EFFECT_TOLERANCE;   // the backend compares the effect rounded to 2 dp
}
